import { Overlay } from "./overlay";

import Root from "./root";

export const Customization = {
    Root,
    Overlay,
};
